import PostList from "../components/Post/PostList";
import {Container} from "react-bootstrap";

const Posts = () => {
    return (
        <Container fluid={true}>
            <PostList/>
        </Container>
    )
}

export default Posts;